<template>
  <div>
    <div class="flex justify-between mb-4">
      <div class="flex-grow mr-2">
        <TextInput
          :value="values_clone.trigger_name"
          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
          name="trigger_name"
          type="text"
          :validate-on-input="true"
          label=""
          :placeholder="$t('Trigger Name')"
          :show-label="true"
          @update:modelValue="
            (e) => {
              values_clone.trigger_name = e
            }
          " />
        <div v-if="allLabels.find((l) => l == values_clone.trigger_name)" class="text-red-500">
          {{ $t("Trigger name already exists") }}
        </div>
      </div>
    </div>
    <div v-if="selectedNode.data.values.sub_item == 'record'" class="mb-4">
      <ComboBoxInput
        v-model:current-item="object_type"
        :value="object_type"
        :items="utils.SortedObjectTypes()"
        name="object_type"
        classes="w-full relative dark:text-white"
        input-classes="form-input"
        label-attr="label"
        value-attr="type"
        :is-box-background="true"
        :label="$t('Select Object Type')"
        :placeholder="$t('Select Object Type')"
        :show-label="true"
        :floating-label="false"
        :allow-null="false" />
    </div>
    <AutoCompleteInput
      v-model="values_clone.selected_trigger"
      class="mt-4"
      :show-down-icon="true"
      :show-plus-btn="false"
      :icon="null"
      value-attr="value"
      label-attr="name"
      :placeholder="$t('Select Trigger')"
      :data="trigger_options"
      :value="values_clone.selected_trigger"
      @chosen="
        ($event) => {
          values_clone.selected_trigger = $event.value
          values_clone.selected_trigger_value = null
        }
      "
      @reset="values_clone.selected_trigger = null" />

    <div
      v-if="trigger_options.find((t) => t.value == values_clone.selected_trigger)?.trigger_value_input_type == 'number'"
      class="flex w-full mt-4 ml-auto rounded-md shadow-sm">
      <div class="relative flex items-stretch flex-grow focus-within:z-10">
        <div class="absolute inset-y-0 z-50 flex items-center pl-3 pointer-events-none right-2 text-common-grey">
          {{ trigger_options.find((t) => t.value == values_clone.selected_trigger)?.trigger_value_input_suffix }}
        </div>
        <TextInput
          :value="values_clone.selected_trigger_value"
          input-classes="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
          name="goal_name"
          :min-value="trigger_options.find((t) => t.value == values_clone.selected_trigger)?.min_value"
          :max-value="trigger_options.find((t) => t.value == values_clone.selected_trigger)?.max_value"
          type="number"
          :validate-on-input="true"
          :label="trigger_options.find((t) => t.value == values_clone.selected_trigger)?.trigger_value_input_label"
          :placeholder="trigger_options.find((t) => t.value == values_clone.selected_trigger)?.trigger_value_input_label"
          @update:modelValue="
            (e) => {
              values_clone.selected_trigger_value = e
            }
          " />
      </div>
    </div>
    <div
      v-if="values_clone.selected_trigger && values_clone.selected_trigger !== 'is_deleted'"
      class="h-[400px] overflow-auto overflow-x-hidden mt-10">
      <div class="relative font-medium top-2">
        {{ $t("Condition") }} ({{ $t("optional") }}):
      </div>
      <AdvancedMetricsFilterForm
        :result-references="filtered_result_references"
        :selected-trigger="
          selectedNode.data.values.sub_item == 'record' || selectedNode.data.values.sub_item == 'metric'
            ? null
            : selectedNode.data.values.sub_item
        "
        :initial-filter="server_filter"
        :object-type="selectedNode.data.values.sub_item == 'record' ? object_type : 'company'"
        @update="handleUpdateFilter" />
    </div>
  </div>
</template>

<script>
import AdvancedMetricsFilterForm from "@/components/forms/AdvancedMetricsFilterForm.vue"
import AutoCompleteInput from "@/components/shared/AutoCompleteInput.vue"
import ComboBoxInput from "@/components/shared/ComboBoxInput.vue"
import dataService from "@/services/data.service"
import TextInput from "@/components/shared/TextInput.vue"

import { transformMetricFilterToServerFilter } from "@/services/data.transformers"
import { utils } from "@/store/helpers"

export default {
  components: {
    AdvancedMetricsFilterForm,
    AutoCompleteInput,
    ComboBoxInput,
    TextInput,
  },
  props: {
    selectedNode: null,
    allLabels: null,
    previousLabels: null,
    allPreviousLabels: null
  },
  emits: ["updateValues"],
  data() {
    return {
      utils,
      values_clone: {
        selected_trigger: null,
        selected_trigger_value: null,
        trigger_name: ""
      },
      items_selected: [],
      phases_list: [],
      phases_names_list: [],
      suggested_lists: [],
      growth_matrices: [],
      customer_journeys_list: [],
      forecasting_lists: [],
      checklists: [],
      server_filter: null,
      server_filter_valid: false,
      prevent_populating_server_filter: false,
      object_type: null,
    }
  },
  computed: {
  
    filtered_result_references() {
      const list_calc = []
      this.previousLabels.forEach((l) => {
        if (this.selectedNode.data.values.sub_item == "record") {
          if (this.object_type == l.object_type) {
            list_calc.push({
              ...l,
              name: `${l.name}${l.object_to_extract_label ? l.object_to_extract_label : ""}`
            })
            list_calc.push({
              ...l,
              name: `${l.name}${l.object_to_extract_label ? `${l.object_to_extract_label} Parent` : " Parent"}`
            })
          }
        } else {
          if (l.type == this.selectedNode.data.values.sub_item) {
            list_calc.push(l)
          }
        }
      })

      return list_calc
    },
    trigger_options() {
      return this.$store.state.data.playbook_triggers.filter((trigger_option) =>
        trigger_option.for.split("__").includes(this.selectedNode.data.values.sub_item)
      )
    }
  },
  watch: {
    values_clone: {
      deep: true,
      handler() {
        this.handleUpdateValues()
      }
    },
    object_type: {
      deep: true,
      handler() {
        this.handleUpdateValues()
      }
    },
    
  },

  created() {
    this.init()
  },

  methods: {
    
    handleUpdateFilter(filter) {
      const filter_cleaned = []
      filter.forEach((item) => {
        if (item.data_type == "String") {
          if (Array.isArray(item.value)) {
            item.value = String(item.value)
          }
          // let value = item.value.replace(/[']+/g, "")
          filter_cleaned.push({
            ...item,
            value: item.value == null ? "" : item.value.trim()
          })
        } else {
          if (
            item.value == null ||
            item.value == undefined ||
            item.value == "" ||
            item.value == "null" ||
            item.value == "undefined" ||
            item.value == "None"
          ) {
            item.value = null
          } else if (
            (item.data_type == "Date" || item.data_type == "DateTime") &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DD")
          } else if (
            item.data_type == "DateTime" &&
            !(
              item.operator.value == "__DAYS_WITHIN_LAST_X_DAYS__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_AGO__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_AGO__" ||
              item.operator.value == "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" ||
              item.operator.value == "__DAYS_WITHIN_NEXT_X_DAYS__" ||
              item.operator.value == "__DAYS_EXACT_DAYS_FROM_NOW__"
            )
          ) {
            item.value = this.$moment(item.value).format("YYYY-MM-DDTHH:mm:ss")
          }
          filter_cleaned.push({ ...item, value: item.value })
        }
      })
      let parsed_filter = transformMetricFilterToServerFilter([...filter_cleaned])

      if (!this.prevent_populating_server_filter) {
        this.server_filter = parsed_filter.filter
        this.server_filter_valid = parsed_filter.valid
      }

      this.handleUpdateValues()
    },

    generateUniqueTriggerName() {
      let trigger_name = `${this.$utils.capitalize(
        this.selectedNode?.data?.values?.sub_item?.replaceAll("_", " ")
      )} ${this.$utils.capitalize(this.selectedNode?.data?.type)}`
      while (this.allPreviousLabels.map((l) => l.name).includes(trigger_name)) {
        let number_added = 2
        if (!isNaN(parseInt(trigger_name.split(" ")[trigger_name.split(" ").length - 1]))) {
          number_added = parseInt(trigger_name.split(" ")[trigger_name.split(" ").length - 1]) + 1
          trigger_name = trigger_name
            .split(" ")
            .slice(0, trigger_name.split(" ").length - 1)
            .join(" ")
        }
        trigger_name += ` ${number_added}`
      }
      return trigger_name
    },
    init() {
      this.values_clone = this.$utils.clone(this.selectedNode.data.values)

      if (!this.values_clone.trigger_name) {
        setTimeout(() => {
          this.values_clone.trigger_name = this.generateUniqueTriggerName()
        }, 400)
      }

      this.object_type = this.selectedNode.data.values.object_type

      this.prevent_populating_server_filter = true
      this.server_filter = this.selectedNode.data.values.condition

      if (this.server_filter) {
        this.server_filter_valid = true
      }
      setTimeout(() => {
        this.prevent_populating_server_filter = false
      }, 1000)

      this.populateSelectedItems()

      if (
        this.selectedNode.data.values.sub_item == "company" ||
        this.selectedNode.data.values.sub_item == "opportunity" ||
        this.selectedNode.data.values.sub_item == "customer_journey" ||
        this.selectedNode.data.values.sub_item == "phase"
      ) {
        dataService.getJourneys({ page_size: 10 }).then((result) => {
          result.data.results.forEach((customer_journey) => {
            this.customer_journeys_list.push(customer_journey)
            customer_journey.phases.forEach((phase) => {
              this.phases_names_list.push(`${phase.name}`)
              this.phases_list.push(phase)
            })
          })

          this.populateSelectedItems()
        })
      }

      if (
        this.selectedNode.data.values.sub_item == "company" ||
        this.selectedNode.data.values.sub_item == "opportunity" ||
        this.selectedNode.data.values.sub_item == "suggested_list"
      ) {
        dataService
          .getMatrixCompanies({
            type: "suggested",
            include_rollup_metrics: false,
            include_records: false
          })
          .then((result) => {
            result.data.data.forEach((list) => {
              this.suggested_lists.push(list)
            })

            this.populateSelectedItems()
          })
      }

      if (
        this.selectedNode.data.values.sub_item == "company" ||
        this.selectedNode.data.values.sub_item == "opportunity" ||
        this.selectedNode.data.values.sub_item == "growth_matrix"
      ) {
        dataService
          .getMatrixCompanies({
            type: "growth_matrix",
            include_rollup_metrics: false,
            include_records: false
          })
          .then((result) => {
            result.data.data.forEach((list) => {
              this.growth_matrices.push(list)
            })

            this.populateSelectedItems()
          })
      }

      if (
        this.selectedNode.data.values.sub_item == "company" ||
        this.selectedNode.data.values.sub_item == "opportunity" ||
        this.selectedNode.data.values.sub_item == "checklist"
      ) {
        if (this.$store.state.object_types.map((o) => o.type).includes(this.selectedNode.data.values.sub_item)) {
          dataService
            .getForeCastChecklist({
              page_size: 100,
              type: this.selectedNode.data.values.sub_item
            })
            .then((res) => {
              res.data.results.forEach((checklist) => {
                this.checklists.push(checklist)
              })

              this.populateSelectedItems()
            })
        }
      }

      if (this.selectedNode.data.values.sub_item == "forecast") {
        this.$store.state.data.user_forecasts.forEach((forecast) => {
          this.forecasting_lists.push(forecast)
        })

        this.populateSelectedItems()
      }

      this.handleUpdateValues()
    },
    populateSelectedItems() {
      this.items_selected = []
      if (
        this.selectedNode.data.values.sub_item == "plan" ||
        this.selectedNode.data.values.sub_item == "task" ||
        this.selectedNode.data.values.sub_item == "goal" ||
        this.selectedNode.data.values.sub_item == "interaction"
      ) {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          dataService[`get${this.$utils.capitalize(this.selectedNode.data.values.sub_item)}`](id).then((res) => {
            this.items_selected.push(res.data)
            if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
              this.handleUpdateValues()
            }
          })
        })
      }
      if (this.$store.state.object_types.map((o) => o.type).includes(this.selectedNode.data.values.sub_item)) {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          this.$store.dispatch("data/getRecord", id).then((res) => {
            this.items_selected.push(res.data)
            if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
              this.handleUpdateValues()
            }
          })
        })
      }

      if (this.selectedNode.data.values.sub_item == "customer_journey") {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          if (this.customer_journeys_list.find((j) => j.id == id)) {
            this.items_selected.push(this.customer_journeys_list.find((j) => j.id == id))
          }
          if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
            this.handleUpdateValues()
          }
        })
      }

      if (this.selectedNode.data.values.sub_item == "phase") {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          if (this.phases_list.find((j) => j.id == id)) {
            this.items_selected.push(this.phases_list.find((j) => j.id == id))
          }
          if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
            this.handleUpdateValues()
          }
        })
      }

      if (this.selectedNode.data.values.sub_item == "growth_matrix") {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          if (this.growth_matrices.find((j) => j.id == id)) {
            this.items_selected.push(this.growth_matrices.find((j) => j.id == id))
          }
          if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
            this.handleUpdateValues()
          }
        })
      }

      if (this.selectedNode.data.values.sub_item == "suggested_list") {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          if (this.suggested_lists.find((j) => j.id == id)) {
            this.items_selected.push(this.suggested_lists.find((j) => j.id == id))
          }
          if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
            this.handleUpdateValues()
          }
        })
      }

      if (this.selectedNode.data.values.sub_item == "forecast") {
        this.selectedNode.data.values.selected_items?.forEach((id) => {
          if (this.forecasting_lists.find((j) => j.id == id)) {
            this.items_selected.push(this.forecasting_lists.find((j) => j.id == id))
          }
          if (this.items_selected.length == this.selectedNode.data.values.selected_items.length) {
            this.handleUpdateValues()
          }
        })
      }
    },

    handleUpdateValues() {
      let valid_calc = true
      if (!this.values_clone?.selected_trigger) {
        valid_calc = false
      }

      if (this.selectedNode.data.values.sub_item == "record" && !this.object_type) {
        valid_calc = false
      }

      if (!this.values_clone?.trigger_name) {
        valid_calc = false
      }

      if (
        (this.selectedNode.data.values.sub_item == "record" || this.selectedNode.data.values.sub_item == "metric") &&
        !this.server_filter
      ) {
        valid_calc = false
      }

      if (this.server_filter && !this.server_filter_valid) {
        valid_calc = false
      }

      if (this.allLabels.find((l) => l == this.values_clone.trigger_name)) {
        valid_calc = false
      }

      const data = {
        ...this.values_clone,
        condition: this.server_filter_valid ? this.server_filter : "",
        selected_trigger_value: this.trigger_options.find((t) => t.value == this.values_clone.selected_trigger)?.trigger_value_input_type
          ? this.values_clone?.selected_trigger_value
          : null,
        selected_items: this.items_selected.map((a) => (a.id ? a.id : a.name)),
        reference_name: this.$utils.slugify(this.values_clone?.trigger_name),
        valid: valid_calc,
        object_type: this.object_type
      }

      this.$emit("updateValues", data)
    }
  }
}
</script>
